import React, { Suspense } from 'react';

const PaymentModalLazy = React.lazy(() => import(/* webpackChunkName: "payment__PaymentModal" */ './payment/PaymentModal'));

export const PaymentModal = () => (
    <Suspense fallback={null}>
        <PaymentModalLazy />
    </Suspense>
);